import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { en, fr } from './i18n';

export function EmptyBag({ isAuth }) {
    const { i18n, t } = useTranslation('shoppingbag');
    i18n.addResourceBundle('en', 'shoppingbag', en, true, true);
    i18n.addResourceBundle('fr', 'shoppingbag', fr, true, true);
    return (
        <>
            <h1 className="bag__title">Your Shopping Bag</h1>
            <p className="bag__para">{t('Your shopping bag is empty, but you can change that!')}</p>
            {!isAuth && (
                <p className="bag__para">
                    {t('If you have previously added items,')}{' '}
                    <a href="/pages/signin" className="bag__link--signin">
                        {t('Sign in')}
                    </a>{' '}
                    {t('to see what’s in your shopping bag.')}
                </p>
            )}

            <p className="bag__para">
                {t('We have thousands of products to choose from. Go ahead and find something you like!')}
            </p>
        </>
    );
}
